import React from "react";
import { useDispatch } from "react-redux";
import { editCategory, removeCategoryChanges } from "../actions/boardActions";

import { GrabberIcon, PencilIcon, XIcon } from "@primer/octicons-react";

export const CategoryControls = ({ category, provided }) => {
  const dispatch = useDispatch();
  return (
    <>
      <button className="btn btn--reorder" {...provided.dragHandleProps}>
        <GrabberIcon />
      </button>
      <button
        className="btn btn--edit"
        onClick={() => {
          dispatch(editCategory(category));
        }}
      >
        <PencilIcon />
      </button>
      <button
        className="btn btn--remove"
        onClick={() => {
          dispatch(removeCategoryChanges(category));
        }}
      >
        <XIcon />
      </button>
    </>
  );
};
